// src/pages/admin/AdminMessagesPage.js
import React, { useState, useEffect } from 'react';
import SendMessageForm from '../../SendMessageForm';
import MensagensEnviadas from '../../MensagensEnviadas'; // NOVO IMPORT
import { auth, db } from '../../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { Divider } from '@mui/material';

function AdminMessagesPage() {
    const user = auth.currentUser;
    const [allUsers, setAllUsers] = useState([]);

    useEffect(() => {
        const fetchAllUsers = async () => {
            const allUsersSnapshot = await getDocs(collection(db, "usuarios"));
            const lista = allUsersSnapshot.docs.map(d => ({ ...d.data(), id: d.id }));
            lista.sort((a, b) => (a.nome || '').localeCompare(b.nome || '', 'pt-BR'));
            setAllUsers(lista);
        };
        fetchAllUsers();
    }, []);

    return (
        <>
            <SendMessageForm user={user} recipientList={allUsers} senderName="Administrador" />
            
            <Divider sx={{ my: 4 }} />
            
            {/* Adiciona o Histórico */}
            <MensagensEnviadas user={user} />
        </>
    );
}

export default AdminMessagesPage;